/* Figma: tables 2161:4831 (Category) / 2161:5594 (City) / 2161:6303 (SKU)
   Row 70px, header 52px, 8px radius on the top corners (2161:7520 rounded-tr). */
.table {
  width: var(--table-w);
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  overflow: hidden;
}

.headerRow, .row { display: grid; }

.row { height: var(--row-h); }
.row.selected { background: var(--bg-row-selected); }

/* ---------- header ---------- */
.headerCell {
  display: flex;
  align-items: center;
  height: var(--header-h);
  padding: 16px 8px;
  background: var(--bg-table-header);
  border-top: 1px solid var(--border-cell);
  border-bottom: 1px solid var(--border-cell);
  border-right: 1px solid var(--border-cell);
}
.headerCell:first-child { border-left: 1px solid var(--border-cell); }
.headerAlignLeft { justify-content: flex-start; }
.headerAlignCenter { justify-content: center; }
.headerAlignRight { justify-content: flex-end; }

.headerLabel {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
  color: var(--text-header);
  letter-spacing: var(--letter-spacing);
  white-space: nowrap;
}
.infoIcon { width: 12px; height: 12px; flex-shrink: 0; }

/* ---------- shared cell chrome ---------- */
.cell {
  border-bottom: 1px solid var(--border-cell);
  border-right: 1px solid var(--border-cell);
  min-width: 0;
}

/* ---------- label column ---------- */
.labelCell {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 4px 12px;
  border-left: 1px solid var(--border-cell);
  /* A grid item will not shrink below its content unless told to, which is
     what let a long SKU name push out of its column and run across the PSL
     cell next door. */
  min-width: 0;
  overflow: hidden;
}
.labelStack {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 8px;
  /* Shrinkable, so the name truncates to whatever the column actually gives
     it. This used to be `flex: 0 0 auto` with the truncation deferred to a
     `--label-max-width` custom property that was never defined anywhere — so
     max-width resolved to `none` and "Scalpe Pro Daily Anti Dandruff Shampoo"
     simply overflowed. Deriving the width from the column removes the magic
     number instead of picking one. */
  flex: 1 1 auto;
  min-width: 0;
}
.labelText {
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
  color: var(--text-value);
  letter-spacing: var(--letter-spacing);
  white-space: nowrap;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
}
.thumb { width: 50px; height: 50px; flex-shrink: 0; border-radius: 8px; object-fit: cover; }

.pills { display: flex; align-items: flex-start; }
.pill {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  height: 18.28px;
  padding: 0 6px;
  background: var(--bg-pill);
  border-radius: var(--radius-sm);
  font-size: 10px;
  font-weight: 500;
  line-height: 14.286px;
  color: var(--text-pill);
  white-space: nowrap;
}
.row.selected .pill { background: var(--bg-pill-on-selected); }
.pillIcon { width: 10px; height: 10px; flex-shrink: 0; }

/* ---------- PSL ---------- */
.pslCell { display: flex; align-items: center; justify-content: center; }

/* ---------- metric (value + delta + sparkline) ---------- */
.metricCell {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: space-between;
  padding: 10px 12px;
}
/* DOI / SOH carry no sparkline, so their value is vertically centred */
.valueCell {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
  padding: 10px 12px;
}

.valueLine { display: flex; align-items: center; gap: 4px; line-height: 16px; white-space: nowrap; }
.value {
  font-size: 12px;
  font-weight: 600;
  color: var(--text-value);
  letter-spacing: var(--letter-spacing);
}
.row.selected .value { color: var(--text-value-selected); }
.delta { font-size: 10px; font-weight: 400; }
.deltaUp { color: var(--delta-up); }
.deltaDown { color: var(--delta-down); }

/* ---------- actions ---------- */
.actionsCell { display: flex; align-items: center; justify-content: center; padding: 4px 12px; }
.actionsBtn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  padding: 4px;
  border-radius: var(--radius-sm);
}
.actionsBtn:hover { background: rgba(0, 0, 0, 0.05); }
.actionsIcon { width: 0.938px; height: 10px; flex-shrink: 0; }

/* ---- loading skeleton ------------------------------------------------- */
/* The frame stays; only the values are absent. Same paddings and alignment
   as the real cells, so nothing shifts when the data lands. */
.skeletonCell { pointer-events: none; }

.shimmer {
  display: block;
  border-radius: 4px;
  background: linear-gradient(90deg, #eceef1 25%, #f6f7f9 37%, #eceef1 63%);
  background-size: 400% 100%;
  animation: shimmer 1.4s ease-in-out infinite;
}

.shimmerLabel { width: 118px; height: 12px; }
.shimmerPill  { width: 64px;  height: 10px; margin-top: 6px; }
.shimmerBadge { width: 52px;  height: 22px; border-radius: 11px; }
.shimmerValue { width: 56px;  height: 12px; }
.shimmerSpark { width: 96px;  height: 14px; margin-top: 6px; opacity: 0.65; }

@keyframes shimmer {
  0%   { background-position: 100% 50%; }
  100% { background-position: 0 50%; }
}

/* Respect a user who has asked for less motion: the placeholder still reads
   as "not loaded", it just stops moving. */
@media (prefers-reduced-motion: reduce) {
  .shimmer { animation: none; }
}
